import { CommonModule } from '@angular/common'
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { notifications } from 'src/app/ngrx/store/actions'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { NotificationService } from 'src/app/service/notifications/notification.service'

import { Notification } from 'src/app/service/notifications/notification.service'
import { NotificationContentComponent } from 'src/app/shared/ddc/ddc-navbar/notification-content.component'

@Component({
  selector: 'ddc-notifications',
  templateUrl: './ddc-notifications.component.html',
  styleUrls: ['./ddc-notifications.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [AngularMaterialsModules, CommonModule, RouterModule, NotificationContentComponent],
})
export class DdcNotificationsComponent implements OnInit {
  notifications: Notification[] = []
  loading = false
  page = 1
  hasMore = true
  debounceTimeout: any = null

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(notifications())
    this.logger.info('DdcNotificationsComponent: ngOnInit called')
    this.loadNotifications(true)
  }

  loadNotifications(autoFill: boolean = false): void {
    if (this.loading || !this.hasMore) return
    this.loading = true
    this.notificationService.get_notifications_page(this.page).subscribe({
      next: response => {
        this.notifications = [...this.notifications, ...response.results]
        this.hasMore = !!response.next
        this.page += 1
        this.loading = false
        // Auto-fetch more if not scrollable and more pages exist
        if (autoFill && this.hasMore) {
          setTimeout(() => {
            const container = document.querySelector('.notification-list-container') as HTMLElement
            if (container && container.scrollHeight <= container.clientHeight + 10) {
              this.loadNotifications(true)
            }
          }, 100)
        }
      },
      error: error => {
        this.logger.error('DdcNotificationsComponent: Error fetching notifications:', error)
        this.loading = false
      },
    })
  }

  onScroll(event: Event): void {
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => {
      const target = event.target as HTMLElement
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 100) {
        this.loadNotifications()
      }
    }, 150)
  }

  getNotificationIcon(type: string): string {
    switch (type) {
      case 'like':
        return 'favorite'
      case 'follow':
        return 'person_add'
      default:
        return 'notifications'
    }
  }

  getNotificationMessage(notification: Notification): string {
    return notification.message || ''
  }
}
